import * as React from 'react';
import { createElement } from 'react';
import Table from './table';
const CbayelArrayForm = (props, ref) => {
    return createElement(Table, { ...props, ...props?.field?.init(props.name), ref: ref });
};
const CbayelArrayFormRef = React.forwardRef(CbayelArrayForm);
export default CbayelArrayFormRef;
